module.exports = __webpack_public_path__ + "static/media/arrow-outlined-right.83515b1f.svg";